import PropTypes from 'prop-types'
import React, { useEffect, useLayoutEffect, useState } from "react"

import { Switch, BrowserRouter as Router, useHistory, useLocation, matchPath } from "react-router-dom"
import { connect, useSelector } from "react-redux"

// Import Routes all
import { userRoutes, authRoutes } from "./routes/allRoutes"

// Import all middleware
import Authmiddleware from "./routes/middleware/Authmiddleware"
import { SessionProvider } from "./routes/middleware/SessionContext"

// layouts Format
import VerticalLayout from "./components/VerticalLayout/"
import HorizontalLayout from "./components/HorizontalLayout/"
import NonAuthLayout from "./components/NonAuthLayout"

// Import scss
import "./assets/scss/theme.scss"
import "./assets/scss/preloader.scss"
//  company helpers
import {
  GET_COMPANY_FROM_URL,

} from "./components/Common/CommonFunction"
import Error404 from './pages/Utility/Error404'
import { useDispatch } from 'react-redux'
import { fetchCompanyTheme } from './store/Administrator/CompanyRedux/actions'
import Loader from './components/CommonLoader/Loder'
import { Company_Theme_List_API } from './helpers/backend_helper'
import UpdateNotification from './pages/Authentication/UpdateNotification'



const App = props => {


  const history = useHistory();
  const dispatch = useDispatch();


  const location = useLocation();
  const company = GET_COMPANY_FROM_URL();
  const loginTimestamp = sessionStorage.getItem("foreceReload");
  const [themeLoadingLocal, setThemeLoadingLocal] = useState({ loading: true, AuthorizeCompany: false, isValidRoute: false });



  useEffect(() => {

    const loadTheme = async () => {
      let AuthorizeCompany = false
      let response;
      try {
        setThemeLoadingLocal({ loading: true, AuthorizeCompany: AuthorizeCompany });

        if (company !== "Default") {
          response = await Company_Theme_List_API(company);
        }
        if ((response?.Status === true && response?.StatusCode === 200)) {
          AuthorizeCompany = true
          localStorage.setItem(`${company}_companyTheme`, JSON.stringify(response?.Data));
          localStorage.setItem(`${company}_companyCode`, response?.Data?.CompanyAbbreviation);
          localStorage.setItem(`${company}_companyID`, response?.Data?.id);

        } else if (company === "Default") {
          AuthorizeCompany = true
        }
        else {
          AuthorizeCompany = false
        }

      } catch (error) {
        console.error(error);
      } finally {
        const allRoutes = [...authRoutes, ...userRoutes];

        const isValidRoute = allRoutes.some(route => {
          const path = route.path.startsWith("/") ? route.path : `/${route.path}`;

          let Company = ""

          if (company === "Default") {
            Company = ""
          } else if ((response?.Status === true && response?.StatusCode === 200)) {
            Company = `/${response?.Data?.CompanyAbbreviation}`
          }

          const companyPath = `${Company}${path}`;

          const match =
            location.pathname === companyPath ||
            location.pathname.startsWith(companyPath + "/");

          const ExactPathMatch = matchPath(location.pathname, {
            path: companyPath,
            exact: false,
            strict: false
          });

          if (ExactPathMatch && ExactPathMatch.isExact) {
            AuthorizeCompany = true
            return ExactPathMatch;
          }

          return match;
        });
        setThemeLoadingLocal({ loading: false, AuthorizeCompany: AuthorizeCompany, isValidRoute: isValidRoute });
      }
    };

    loadTheme();
  }, [company]);





  const userPageAccess = history.location.state

  function getLayout() {
    let layoutCls = VerticalLayout
    switch (props.layout.layoutType) {
      case "horizontal":
        layoutCls = HorizontalLayout
        break
      default:
        layoutCls = VerticalLayout
        break
    }
    return layoutCls
  }

  const Layout = getLayout()


  if (themeLoadingLocal.loading) {
    return <Loader />;
  }

  if (!((themeLoadingLocal.isValidRoute) && (themeLoadingLocal.AuthorizeCompany))) {
    return (
      <NonAuthLayout>
        <Error404 />
      </NonAuthLayout>
    );
  }

  return (
    <React.Fragment>
      <Router basename={(company !== "Default") && (localStorage.getItem(`${company}_companyCode`) === company) ? `/${company}` : "/"}>
        <Switch>
          <SessionProvider history={history} >
            <UpdateNotification />
            {authRoutes.map((route, idx) => (
              <Authmiddleware
                path={route.path}
                layout={NonAuthLayout}
                component={route.component}
                key={idx}
                history={history}
                isAuthProtected={false}
                exact
              />
            ))}

            {userRoutes.map((route, idx) => (
              <Authmiddleware
                path={route.path}
                layout={Layout}
                component={route.component}
                key={ route.remountOnLogin ? `${route.idx}_${loginTimestamp}` : idx}
                isAuthProtected={true}
                userPageAccess={userPageAccess}
                history={history}
                isPartyWisePage={route.isPartyWisePage}
                exact
              />
            ))}
          </SessionProvider>
        </Switch>
      </Router>
    </React.Fragment>
  )
}

App.propTypes = {
  layout: PropTypes.any
}

const mapStateToProps = state => {
  return {
    layout: state.Layout,
  }
}

export default connect(mapStateToProps, null)(App)

